import Divider from '@components/Divider';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';

import Agreements from '../Agreements';
import Certification from '../Certification';

function CertificationForm() {
    const project = useProject();
    return (
        <Contents>
            {(!project?.features.authenticationEnabled) && (
                <Fragment>
                    <Certification/>
                    <Divider/>
                </Fragment>
            )}
            <Agreements/>
        </Contents>
    );
}

const Contents = styled.div`
    flex: 1;
    overflow-y: auto;
    width: 100%;
`;

export default CertificationForm;
